import { CmsApiVideoBlockData } from 'modules/cms/api/types/CmsApiVideo';
import { CmsBlockWidth } from 'modules/cms/api/types/CmsBlockWidth';
import { CmsBlockMapping } from 'modules/cms/blocks/CmsBlockMapping';

import { CmsAmpVideoBlock } from './CmsAmpVideoBlock';
import { CmsVideoBlock } from './CmsVideoBlock';

export const CmsVideoBlockMapping: CmsBlockMapping<CmsApiVideoBlockData> = {
  invariant: [
    {
      prop: 'videoUrl',
      msg: 'URL required for video',
    },
    {
      prop: 'width',
      msg: 'width required for video',
    },
  ],
  width: ({ width }) =>
    width === 'WIDE' ? CmsBlockWidth.INSET : CmsBlockWidth.NARROW,
  Component: CmsVideoBlock,
  AmpComponent: CmsAmpVideoBlock,
};
